export const nl = {
  title: 'Koolstofaccumulatiepotentieel door natuurlijke hergroei van bossen in herbebossbare gebieden',
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Functie',
      value:
        'Schat de snelheid waarmee koolstof kan worden vastgelegd in bovengrondse levende biomassa tijdens de eerste dertig jaar van natuurlijke hergroei van bossen in potentieel herbebossbare gebieden (Mg koolstof/ha/jaar).',
    },
    {
      label: 'Resolutie',
      value: '1 × 1 km',
    },
    {
      label: 'Geografische dekking',
      value:
        'Globaal, binnen de herbebossingsomvang van Griscom et al. 2017 (exclusief de boreale, met gras begroeide biomen en akkerlanden)',
    },
    {
      label: 'Bron',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: 'Frequentie',
      value: '',
    },
    {
      label: 'Datum van inhoud',
      value: 'Van toepassing op de eerste 30 jaar van natuurlijke hergroei van bossen.',
    },
    {
      label: 'Waarschuwingen',
      value:
        '- Waarden vertegenwoordigen de beste schattingen, maar bevatten onzekerheid. De nauwkeurigheid van de resultaten is afhankelijk van de beschikbaarheid van gegevens voor modeltraining, die geconcentreerd is in tien landen. De onzekerheidskaart die bij deze gegevenslaag hoort, kan worden gedownload van het Open Data Portal van GFW.\n- Koolstofaccumulatiesnelheden zijn alleen van toepassing op natuurlijke hergroei van bossen en zijn niet van toepassing op andere actieve herstelmethoden (agroforestry, plantages, enz.).\n- De accumulatiesnelheden van koolstof zijn lineair en worden gemiddeld over de eerste 30 jaar van hergroei. Als we verder dan 30 jaar rekken, wordt de sekwestratie overschat.\n- De tarieven weerspiegelen alleen de koolstofaccumulatie in bovengrondse levende biomassa. Accumulatie in ondergrondse biomassa, dode organische stof en organische koolstof in de bodem zijn niet inbegrepen, maar een ondergrondse koolstofaccumulatiekaart is op aanvraag beschikbaar.\n- In savannes gelden de tarieven alleen voor beboste delen van deze grasland-bosmatrices.\n- Deze gegevens zijn geen vervanging voor gedetailleerde beoordelingen op locatieniveau van het potentieel voor boshergroei.',
    },
    {
      label: 'Licentie',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Deze kaart toont de snelheid waarmee bossen koolstof uit de atmosfeer kunnen opvangen en opslaan in bovengrondse levende biomassa gedurende de eerste 30 jaar van natuurlijke hergroei van bossen. Het is gemaakt door metingen op de grond op duizenden locaties over de hele wereld te combineren met 66 covariate lagen in de omgeving op dezelfde locatie in een machine learning-model om een kaart van muur tot muur te produceren. De gegevens van bospercelen die worden gebruikt om het model te trainen, zijn afkomstig uit gepubliceerde literatuur, die te vinden is in de Forest Carbon-database (ForC, onderhouden door het Smithsonian Institute (https://github.com/forc-db)), evenals gegeorefereerde gegevens uit openbaar beschikbare nationale bosinventarissen. Hoewel de tarieven werden geschat op alle bos- en savannebiomen wereldwijd, worden ze hier gefilterd op "herbebossbaar" gebied, zoals gedefinieerd in Griscom et al. 2017 (PNAS). Herbebosbare gebieden sluiten gebieden met inheemse graslanden en akkerlanden uit om de productie van voedsel en vezels en habitat voor biologische diversiteit te beschermen.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
